/** Kursiyere göre filtrelenmiş ders detay raporları listesi */
export function lessonReportsPathForStudent(studentId: string): string {
  return `/lesson-reports?student=${encodeURIComponent(studentId)}`;
}
